import {
  Divider,
  DialogContent,
  Dialog,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Typography,
} from '@mui/material';

import { Strings } from '@app/constants';
import { Header } from '@app/sections/header';
import { useSearch } from '@app/hooks';
import { CustomAvatar } from '@app/components';
import { IOverdueTasks } from '../type';

interface Props {
  open: boolean;
  onClose: VoidFunction;
  onSelectProject: (project: any) => void;
  data: any;
}

const SearchProject = ({ open, onClose, onSelectProject, data }: Props) => {
  const uniqueAssignees: IOverdueTasks[] = data.filter(
    (task: IOverdueTasks, index: number, self: IOverdueTasks[]) =>
      self.findIndex((t) => t?.boardName === task?.boardName) === index
  );

  const searchProps = useSearch({
    data: uniqueAssignees,
    fields: ['projectName', 'id'],
  });

  return (
    <>
      <Dialog open={open} onClose={onClose}>
        <Header
          variant="dialog"
          title={Strings.taskBoard.searchBoardName}
          onClose={onClose}
          searchBarProps={{
            placeholder: Strings.common.search,
            onChange: searchProps.handleSearchChange,
          }}
        />
        <Divider />
        <DialogContent>
          {searchProps?.filteredRows && searchProps?.filteredRows?.length > 0 ? (
            <List>
              {searchProps.filteredRows.map((project) => (
                <ListItem
                  key={project.id}
                  onClick={() => {
                    onSelectProject(project);
                    onClose();
                  }}
                >
                  <ListItemIcon>
                    <CustomAvatar
                      name={project?.projectName}
                      src={project?.projectImage}
                      color={project?.projectImage ? 'default' : 'info'}
                      sx={{
                        '& img': {
                          objectFit: 'cover',
                        },
                      }}
                    />
                  </ListItemIcon>
                  <ListItemText primary={project.projectName} />
                </ListItem>
              ))}
            </List>
          ) : (
            <Typography variant="body1" sx={{ textAlign: 'center', padding: 2 }}>
              {Strings.taskBoard.noBoardFound}
            </Typography>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};

export default SearchProject;
